// Inverse of encodeTagsParam: split the `tags` query param on the comma
// delimiter, then percent-decode each pair so a value that contained a comma is
// restored intact. Legacy/hand-crafted params with raw (unencoded) pairs decode
// as a no-op, so `?tags=repoName:repo-a` still works. Malformed percent
// sequences fall back to the raw segment rather than throwing.
export function decodeTagsParam(param: string): string[] {
  return param
    .split(',')
    .map((segment) => {
      try {
        return decodeURIComponent(segment)
      } catch {
        return segment
      }
    })
    .filter((pair) => pair.length > 0)
}
